import { PoolAccordionSummary } from '@synergy/components-next';
import { styled } from '@mui/material';

export const FilterAccordionSummary = styled(PoolAccordionSummary, {
    shouldForwardProp: prop => prop !== 'filterActive',
})<{
    filterActive?: boolean;
}>(({ theme, filterActive }) => ({
    minHeight: 62,
    padding: theme.spacing(1.5, 0, 1.5, 2),

    '&&.Mui-expanded': {
        backgroundColor: theme.palette.grey[200],
    },

    ...(filterActive && {
        backgroundColor: theme.palette.grey[200],
    }),
}));
